import React from "react";
import { Field } from "formik";

import styles from "./EmailInput.module.scss";

import { FieldPropsType, EmailInputPropsType } from "./types";

export const EmailInput: React.FC<EmailInputPropsType> = (props) => {
  const { name, focusThisInput = false, placeholder, lable } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    if (focusThisInput) {
      inputRef.current?.focus();
    }
  }, []);

  return (
    <Field name={name}>
      {(fieldProps: FieldPropsType) => {
        const { field, meta } = fieldProps;
        const hasValue = !!meta.value && meta.value.length > 0;
        const shouldShowLabelFocus = isFocused || hasValue;

        return (
          <div className={styles.inputWrapper}>
            <label
              htmlFor={name}
              className={`
                ${styles.label}
                ${shouldShowLabelFocus && styles.labelFocus}
              `}>
              {lable}
            </label>
            <input
              ref={inputRef}
              type="text"
              inputMode="email"
              autoComplete="email"
              id={name}
              className={`
                ${styles.input}
                ${meta.touched && meta.error ? styles.error : null}
                ${shouldShowLabelFocus ? styles.inputFocus : null}
              `}
              {...field}
              onFocus={(e) => {
                setIsFocused(true);
                if ('onFocus' in field && typeof field.onFocus === 'function') {
                  field.onFocus(e);
                }
              }}
              onBlur={(e) => {
                setIsFocused(false);
                if ('onBlur' in field && typeof field.onBlur === 'function') {
                  field.onBlur(e);
                }
              }}
            />
          </div>
        );
      }}
    </Field>
  );
};
